import { Box, Flex, Icon, Text, desktopFirstMediaQuery } from '@inflearn/ds-react';
import { useLang } from '@inflearn/i18n-tools';
import { faBuildingCircleCheck } from '@inflearn/pro-regular-svg-icons/faBuildingCircleCheck';
import useInstructorProfileQuery from '../../../../../../hooks/useInstructorProfileQuery';
import useQueryParams from '../../../../../../hooks/useQueryParams';

const HIDDEN_JOB_LEVEL = ['INTERN', 'BEGINNER', 'JUNIOR'];

export function MentoringInformation() {
  const { id } = useQueryParams();
  const { data: instructorProfile } = useInstructorProfileQuery({
    userId: String(id),
    isInstructor: true,
  });
  const { isKo } = useLang();

  if (!instructorProfile) {
    return null;
  }

  if (!(isKo && Boolean(instructorProfile.mentor?.isActive))) {
    return null;
  }

  const isNotHiddenJobLevel =
    instructorProfile.mentor?.jobLevel &&
    !HIDDEN_JOB_LEVEL.includes(instructorProfile.mentor.jobLevel.code);

  return (
    <Box
      w={'100%'}
      css={{
        [desktopFirstMediaQuery.tablet]: {
          marginTop: 0,
        },
      }}
    >
      <Flex>
        {isNotHiddenJobLevel ? (
          <Text size="xs" weight={500} lineClamp={1} mr={5} color={'gray.6'}>
            {instructorProfile.mentor?.jobLevel?.name}
            <Text component="span" size="xs" ml={5} weight={500} color={'gray.6'}>
              ·
            </Text>
          </Text>
        ) : null}
        {instructorProfile.mentor?.job ? (
          <Text size="xs" weight={500} color="gray.6" lineClamp={1}>
            {instructorProfile.mentor.job}
          </Text>
        ) : null}
      </Flex>
      {instructorProfile.mentor?.companyName ? (
        <Flex gap={2} align="center">
          <Icon icon={faBuildingCircleCheck} size="xs" color="infgreen.7" />
          <Text color="infgreen.7" lineClamp={1} weight={500} size="sm">
            {instructorProfile.mentor.companyName}
          </Text>
        </Flex>
      ) : null}
    </Box>
  );
}
